var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStudentGroups = function SvgStudentGroups(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#292929",
    d: "M16.875 3.125H3.125a1.25 1.25 0 0 0-1.25 1.25v11.25a1.25 1.25 0 0 0 1.25 1.25h1.046a.63.63 0 0 0 .565-.357 3.75 3.75 0 0 1 6.778 0 .63.63 0 0 0 .565.357h4.796a1.25 1.25 0 0 0 1.25-1.25V4.375a1.25 1.25 0 0 0-1.25-1.25M6.25 11.25a1.875 1.875 0 1 1 3.75 0 1.875 1.875 0 0 1-3.75 0m10.625 4.375h-4.42a5.03 5.03 0 0 0-2.252-2.044 3.124 3.124 0 1 0-4.156 0 5.03 5.03 0 0 0-2.252 2.044h-.67V4.375h13.75zM4.375 7.5V6.25A.625.625 0 0 1 5 5.625h10a.625.625 0 0 1 .625.625v7.5a.624.624 0 0 1-.625.625h-1.25a.624.624 0 1 1 0-1.25h.625v-6.25h-8.75V7.5a.625.625 0 0 1-1.25 0"
  })));
};
export default SvgStudentGroups;